import styled from 'styled-components';

import type { BasketContentItemWithPrices, Universe } from '@front/common/src/types/commons';
import { getBasketCategoryPrestationsList } from '@front/common/src/utils/basket';

import Text from '@front/web-ui/src/components/base-text/variants/text';

import { CategoryLine, PrestationsList } from '../../../common/common';
import PrestationItem from './prestation-item';

export const StyledPriceLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

type CategoryProps = {
  basketContentItem: BasketContentItemWithPrices;
  title: string;
  universe: Universe;
};

const Category = ({ basketContentItem, title, universe }: CategoryProps) => {
  const prestations = getBasketCategoryPrestationsList(
    basketContentItem.reference,
    universe,
    basketContentItem.prestations,
  );

  return (
    <CategoryLine>
      <StyledPriceLine>
        <Text.MDBold>{title}</Text.MDBold>
      </StyledPriceLine>
      <PrestationsList>
        {prestations.map((prestation, index) => (
          <PrestationItem
            key={prestation?.reference || index}
            prestation={prestation}
            price={prestation && basketContentItem.prestationsPrices[prestation.reference]}
          />
        ))}
      </PrestationsList>
    </CategoryLine>
  );
};

export default Category;
